import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-have-questions',
	templateUrl: './have-questions.component.html'
})
export class HaveQuestionsComponent implements OnInit {

	constructor() { }

	ngOnInit(): void {
	}

}
